import React from "react";
import { FaWhatsapp, FaTwitter, FaLinkedinIn, FaGithub } from "react-icons/fa";
import { contactImg } from "../../assets/index";

const ContactLeft = () => {
  return (
    <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r  from-[#fdfdfd] to-[#fafafa] dark:from-[#1e2024] dark:to-[#23272b] p-4 lgl:p-8 rounded-lg shadow-shadowOne dark:shadow-[#1c1e22] shadow-gray-200 flex flex-col gap-8 justify-center">
      <img
        className="w-full h-64 object-cover rounded-lg mb-2"
        src={contactImg}
        alt="contactImg"
      />
      <div className="flex flex-col gap-4">
        <h3 className="text-3xl font-bold dark:text-white text-black">M Kashif Bilal</h3>
        <p className="text-lg font-normal dark:text-gray-400 text-black">
          Full-stack Developer
        </p>
        <p className="text-base dark:text-gray-400 text-black tracking-wide">
          If you're looking for a skilled and motivated web developer, I would
          love to connect with you!
        </p>
        <p className="text-base font-semibold dark:text-gray-400 text-black flex items-center gap-2">
          Phone: <span className="text-black dark:text-lightText">+923402550308</span>
        </p>
        <p className="text-base font-semibold dark:text-gray-400 text-black flex items-center gap-2">
          Email: <span className="text-black dark:text-lightText">kashif12702@gmail.com</span>
        </p>
      </div>
      <div className="flex flex-col gap-4">
        <h2 className="text-base uppercase font-titleFont mb-4">Find me in</h2>
        <div className="flex gap-4">
          <a
            target="_blank"
            rel="noreferrer"
            href="https://wa.me/message/NYZ4MQS2TSILJ1"
          >
            <span className="bannerIcon">
              <FaWhatsapp />
            </span>
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://twitter.com/KASHIF12702"
          >
            <span className="bannerIcon">
              <FaTwitter />
            </span>
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.linkedin.com/in/kashif12702/"
          >
            <span className="bannerIcon">
              <FaLinkedinIn />
            </span>
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://github.com/kashif12702"
          >
            <span className="bannerIcon">
              <FaGithub />
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactLeft;
